import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(
          Path,
          {
            d: "M19.3 14.8C20.1 16.4 21 17 21 17H3s3-2 3-9c0-3.3 2.7-6 6-6 1 0 1.9.2 2.8.7",
            stroke: `${color}`
          }
        ),
        /* @__PURE__ */ jsx(Path, { d: "M10.3 21a1.94 1.94 0 0 0 3.4 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M15 8h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M18 5v6", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "BellPlus";
const BellPlus = memo(themed(Icon));
export {
  BellPlus
};
//# sourceMappingURL=bell-plus.js.map
